// export const BASE_URL= 'http://localhost:8000';

export const BASE_URL = 'https://note-taking-appserver.onrender.com';

